import { c as _c } from "react/compiler-runtime";
import InputWithSlider from "@components/InputWithSlider";
import { Button, Modal, ModalProps } from "@justhome/react-ui";
import { FC, useCallback } from "react";
import { Control, useForm, useWatch } from "react-hook-form";
import { RepaymentCalculatorFormValue, RepaymentRateChange } from "./types";
interface CreateRepaymentRateChangeProps extends ModalProps {
  control: Control<RepaymentCalculatorFormValue>;
  onSubmit: (repaymentRateChange: RepaymentRateChange) => void;
  defaultValues?: RepaymentRateChange;
}
const CreateRepaymentRateChange: FC<CreateRepaymentRateChangeProps> = props => {
  const $ = _c(31);
  let t0;
  if ($[0] !== props.control) {
    t0 = {
      name: "fixedInterestPeriodYears",
      control: props.control
    };
    $[0] = props.control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fixedInterestPeriodYears = useWatch(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Date().getFullYear();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const thisYear = t1;
  let t2;
  if ($[3] !== props.defaultValues) {
    t2 = props.defaultValues || {
      year: thisYear + 1,
      repaymentRate: 2
    };
    $[3] = props.defaultValues;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = {
      defaultValues: t2
    };
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    control,
    handleSubmit
  } = useForm(t3);
  let t4;
  if ($[7] !== props) {
    t4 = value => {
      props.onSubmit(value);
    };
    $[7] = props;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onSubmit = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Modal.Title className="text-app-h3">Tilgungswechsel hinzufügen</Modal.Title>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleSubmit || $[11] !== onSubmit) {
    t6 = handleSubmit(onSubmit);
    $[10] = handleSubmit;
    $[11] = onSubmit;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = thisYear + (fixedInterestPeriodYears || 15);
  let t8;
  if ($[13] !== control || $[14] !== t7) {
    t8 = <InputWithSlider format={false} control={control} name="year" label={"Jahr der \xC4nderung"} min={thisYear} max={t7} step={1} />;
    $[13] = control;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== control) {
    t9 = <InputWithSlider control={control} name="repaymentRate" label="Tilgung" min={1} max={10} step={0.1} suffix="%" />;
    $[16] = control;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== props) {
    t10 = <Button onClick={() => props.setIsOpen?.(false)} variant="outline_primary" size="sm">Abbrechen</Button>;
    $[18] = props;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Button type="submit" size="sm">Speichern</Button>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10) {
    t12 = <div className="flex gap-s mt-2xs">{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t6 || $[25] !== t8 || $[26] !== t9) {
    t13 = <form className="flex flex-col gap-s" onSubmit={t6}>{t8}{t9}{t12}</form>;
    $[23] = t12;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== props || $[29] !== t13) {
    t14 = <Modal {...props}>{t5}{t13}</Modal>;
    $[28] = props;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
export default CreateRepaymentRateChange;